import { render, staticRenderFns } from "./ProjectDocumentsTableItem.vue?vue&type=template&id=29114ec6&scoped=true&"
import script from "./ProjectDocumentsTableItem.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentsTableItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDocumentsTableItem.vue?vue&type=style&index=0&id=29114ec6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29114ec6",
  null
  
)

export default component.exports